export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" stroke=\"#00809D\" stroke-width=\"2\" d=\"M24 36c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z\" clip-rule=\"evenodd\"/><path stroke=\"#00809D\" stroke-width=\"2\" d=\"M24 18.5v6m0 4V30\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "fill": "none",
    "viewBox": "0 0 48 48"
  }
};